<template>
  <div class="pagination-container">
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :page-sizes.sync="pageSizes"
      style="text-align: right;margin:20px 0;"
      :layout="layout"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { paginations } from "@/../utils/public";
export default {
  name: "Pagination",
  props: {
    listData:{
      required: true,
      type: Object,
      default:{}
    },
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: paginations.page
    },
    limit: {
      type: Number,
      default: paginations.limit
    },
    pageSizes: {
      type: Array,
      default() {
        return paginations.pageSizes;
      }
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper"
    },
    background: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    currentPage: {
      set(val) {
        this.$emit("update:page", val);
      },
      get() {
        return this.page;
      }
    },
    pageSize: {
      get() {
        return this.limit;
      },
      set(val) {
        this.$emit("update:limit", val);
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      console.log(this.listData);
      this.$emit("pagination", {listRequest: this.listData});//, { page: val, limit: this.pageSize }  不传也可以
    },
    handleCurrentChange(val) {
      console.log('切换页码');
      this.$emit("pagination", {listRequest: this.listData});//, { page: val, limit: this.pageSize }  不传也可以
    }
  }
};
</script>

<style scoped>
.pagination-container {
  background: #fff;
  padding: 32px 16px;
}
</style>